import { useMemo } from 'react';
import { useCodeRepositoryIntegration, useTicketingIntegration } from '.';

type Props = {
  envId?: string;
};

const useEnabledTicketingIntegration = ({ envId }: Props) => {
  const { requireTicketId } = useCodeRepositoryIntegration({ envId });
  const { ticketingQuery } = useTicketingIntegration({ envId });

  const enabledIntegrations = useMemo(
    () =>
      ticketingQuery?.data?.integrations?.filter(
        (integration) => integration.enabled,
      ) ?? [],
    [ticketingQuery?.data?.integrations],
  );

  return {
    requireTicketId,
    enabledIntegrations,
  };
};

export default useEnabledTicketingIntegration;
